<template>
  <div class="video_cup">
    <div v-for="(item,index) in videosArr" :key="index">
      <video width="100%" height="100%" controls>
        <source :src="item.path">
      </video>
      <div class="video_title subTitle">{{item.name}}</div>
    </div>
  </div>
</template>
<script>
import { movieCompany } from '@/api/frontApi/company';
export default {
  data() {
    return {
      urlUnion: [
        {
          path: '',
          name: '公司宣传视频'
        },
        { path: '', name: '超拖1号视频' }
      ],
      videosArr: []
    };
  },
  created() {
    this.getVideos();
  },
  methods: {
    getVideos() {
      movieCompany({ pageNo: 1, pageSize: 500 }).then(res => {
        if (res.result.code === 0) {
          res.data.list.forEach(item => {
            let tempObj = { path: '', name: '' };
            tempObj.path = item.movieUrl;
            tempObj.name = item.movieName;
            this.videosArr.push(tempObj);
          });
        }
      });
    }
  }
};
</script>
<style  scoped>
.video_cup {
  padding: 10px 10px;
}
.video_title {
  height: 50px;
  line-height: 50px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/companyInfos/companyVideos.vue